<template>
  <section id="section-accommodation">
    <SectionHeading id="toc-accommodation" class="heading" icon="icon-hotel-bedroom" title="Accommodation" />

    <div class="hotel-list">
      <div class="hotel" v-for="h in hotels">
        <div class="title">{{ h.title }}</div>
        <div v-if="h.description" class="description" v-html="parseMarkdown(h.description)"></div>
      </div>
    </div>

    <div class="right">
      <MediaGallery :feature-images="images" layout="hotels" />
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { parseMarkdown } from '@/utils'
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import MediaGallery from '@/modules/MediaGallery/MediaGallery.vue'
import DefaultImage from 'app/assets/images/overlands/default_hotel.jpg'

const store = useItineraryStore()
const {
  data: {
    itinerary: { hotels, hotelImages },
  },
} = store
const images = computed(() =>
  hotelImages.length > 0 ? hotelImages : [{ url: DefaultImage, description: 'Resort pool at sunset' }],
)
store.monitorVisibility('accommodation', '#section-accommodation')
</script>

<style lang="scss" scoped>
section {
  display: grid;
  grid-template-columns: 2fr 1fr;
  row-gap: 20px;
  column-gap: 24px;

  @include mobile {
    grid-template-columns: 1fr;
  }
}

.heading {
  grid-column: 1/-1;
}

.hotel-list {
  @include flex-column(32px);

  .title {
    font-weight: 600;
    margin-bottom: 16px;
  }
}

.description:deep {
  @include markdown-display;
}
</style>
